import { AnalyticsService } from './analytics.service'
import { digitalData } from './datalayer'
import * as AnalyticsEvent from './events'

// init data layer
AnalyticsService.setDataLayer(digitalData)

export const Analytics = new AnalyticsService()
export { AnalyticsEvent }
